module.exports = __webpack_public_path__ + "img/vip-executive-zurique-hotel.b3df8824.jpg";